 const API_URL = 'https://backend.pastezen.com';

 module.exports = {
   API_URL
 }